import * as GraphicsLayer from './GraphicsLayer'
import type { GraphicsLayerHandle, GraphicHandle } from './GraphicsLayer'
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol"
import { parcelFeatureToParcelData } from "../../parcels/hooks"
import { SearchResult } from "../../search/types"


let layerHandle: GraphicsLayerHandle = GraphicsLayer.NULL_LAYER_HANDLE

const unselectedSymbol = new SimpleFillSymbol({
  color: [ 119, 119, 119, 0.4 ],
  style: "diagonal-cross",
  outline: {  // autocasts as new SimpleLineSymbol()
    color: [51, 51, 51],
    width: 1
  }
})

const selectedSymbol = new SimpleFillSymbol({
  color:  [ 0, 193, 240, 0.4 ],
  style: "solid",
  outline: { // autocasts as new SimpleLineSymbol()
    color: [0, 154, 191],
    width: 3
  }
})

export const initSearchResultsLayer = (map: __esri.Map, view: __esri.MapView) => {
  layerHandle = GraphicsLayer.createGraphicsLayer(map, view)
}

const createGraphic = (feature: __esri.Graphic): GraphicHandle => {
  const data = parcelFeatureToParcelData(feature.attributes)
  const handle = GraphicsLayer.createGraphic(layerHandle, data, feature.geometry, unselectedSymbol)
  return handle
}

export const addParcels = (type: "Owner" | "PIN" | "TMS", features: __esri.Graphic[]): SearchResult[] => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return []

  let graphicHandles = []
  let results: SearchResult[] = []
  for (let i = 0; i < features.length; i++) {
    const feature = features[i]
    const handle = createGraphic(feature)
    graphicHandles.push(handle)
    results.push({
      type,
      handle, 
      PIN: feature.attributes.PIN,
      label: feature.attributes.OwnerName,
      subLabel: feature.attributes.LegalDescr,
    })
  }
  GraphicsLayer.addGraphics(layerHandle, graphicHandles)
  return results
}

export const getGeometry = (handle: GraphicHandle) => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return undefined
  return GraphicsLayer.getGraphic(layerHandle, handle)?.geometry
}

export const highlightGraphic = (handle: GraphicHandle) => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return
  GraphicsLayer.updateGraphicSymbol(layerHandle, handle, selectedSymbol)
}

export const unhighlightGraphic = (handle: GraphicHandle) => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return
  GraphicsLayer.updateGraphicSymbol(layerHandle, handle, unselectedSymbol)
}

export const clearGraphics = () => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return
  GraphicsLayer.clearGraphics(layerHandle)
}